module.exports = __webpack_public_path__ + "static/media/17UN-Women7.4e498d14.jpg";